import { render, staticRenderFns } from "./Sent.vue?vue&type=template&id=573d6038&scoped=true&"
import script from "./Sent.vue?vue&type=script&lang=js&"
export * from "./Sent.vue?vue&type=script&lang=js&"
import style1 from "./Sent.vue?vue&type=style&index=1&id=573d6038&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "573d6038",
  null
  
)

export default component.exports